<template>
  <div>
    <el-upload ref="upload" class="avatar-uploader" v-model:file-list="newFileList" :list-type="listType"
               :action="action" :show-file-list="showFileList" :headers="headers" :drag="drag"
               :on-success="handleAvatarSuccess" :name="name" :limit="limit" :accept="accept"
               :before-upload="beforeAvatarUpload" :on-exceed="handleExceed" :on-remove="onRemove"
               :on-preview="handlePictureCardPreview" :on-error="onError" :data="data" :disabled="disabled">
      <gljy-button v-if="listType == 'text'" type="primary">上传</gljy-button>
      <el-icon v-else class="avatar-uploader-icon">
        <Plus />
      </el-icon>
    </el-upload>
    <el-image-viewer v-if="dialogVisible" @close="closeImgViewer" :url-list="previewList" :z-index="3000" />
  </div>
</template>

<script>
import { genFileId } from 'element-plus'
import { getUUID } from '@/utils/ruoyi.js'
import { ElMessage } from 'element-plus'
import { getToken } from '@/utils/auth'
import { reactive, toRefs, ref, watch, nextTick } from "vue"
export default {
  name: "gljy-upload",
  emits: ["update:fileUrls", "update:fileNames", "update:fileList", "uploadResult"],
  props: {
    limit: {
      type: Number,
      default: () => {
        return 1;
      }
    },
    // 上传文件字段名
    name: {
      type: String,
      default: "file"
    },
    data: [Object, Function], // 上传字段额外参数
    action: {
      type: String,
      default: () => {
        return import.meta.env.VITE_APP_BASE_API + "/file/upload"
      }
    },
    accept: String, // 接受上传文件类型
    /** 文件列表 */
    fileList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    /** 文件名称 */
    fileUrls: {
      type: String,
    },
    showFileList: {
      type: Boolean,
      default: () => {
        return true
      }
    },
    /** 'text' | 'picture' | 'picture-card' */
    listType: {
      type: String,
      default: "picture-card"
    },
    headers: {
      type: Object,
      default: () => {
        return {
          Authorization: 'Bearer ' + getToken()
        }
      }
    },
    maxSize: {
      type: Number,
      default: () => {
        return 20
      }
    },
    // 是否启用拖拽上传
    drag: {
      type: Boolean
    },
    disabled: Boolean
  },
  setup(props, context) {
    const upload = ref();
    const datas = reactive({
      baseUrl: import.meta.env.VITE_APP_BASE_API,
      // 上传成功处理
      handleAvatarSuccess: (response, uploadFile) => {
        // console.log("response", response, uploadFile)
        context.emit("uploadResult", response);
        const uid = uploadFile.uid;
        if (response.code !== 200) {
          const index = datas.newFileList.findIndex(item => item.uid === uid);
          datas.newFileList.splice(index, 1);
          ElMessage.error(response.msg);
          return false;
        }
        const find = datas.newFileList.find(item => item.uid === uid);
        find.url = response.data.url;
        context.emit("update:fileList", datas.newFileList);
        // 构造数据
        let fileUrls = [];
        let fileNames = [];
        datas.newFileList.forEach(item => {
          let url = "";
          let name = "";
          if (item.isEcho) {
            url = item.url;
            name = item.url;
          } else {
            url = item.response.data.url;
            name = item.response.data.name;
          }
          fileUrls.push(url);
          fileNames.push(name);

          item.url = `${url}?Authorization=${getToken()}`
        })
        context.emit("update:fileUrls", fileUrls.join(","));
        context.emit("update:fileNames", fileNames.join(","));
        setTimeout(() => {
          console.log("datas.newFileList", datas.newFileList)
        })
      },
      beforeAvatarUpload: (rawFile) => {
        // console.log("beforeAvatarUpload", rawFile)
        if (rawFile.size > props.maxSize * 1024 * 1024) {
          ElMessage.error(`上传文件大小不能超过${props.maxSize}MB`);
          return false
        }
        return true
      },
      // 超出文件数量时
      handleExceed: (files) => {
        if (props.limit == 1) {
          datas.newFileList = [];
          setTimeout(() => {
            const file = files[0];
            file.uid = genFileId()
            upload.value.handleStart(file)
            upload.value.submit();
          })
        } else {
          ElMessage.error(`最多上传${props.limit}个文件或图片`);
          return;
        }
      },
      // 删除文件时
      onRemove: (uploadFile, uploadFiles) => {
        console.log("uploadFile, uploadFiles", uploadFile, uploadFiles)
        context.emit("update:fileList", datas.newFileList);
        // 构造数据
        let fileUrls = [];
        let fileNames = [];
        datas.newFileList.forEach(item => {
          let url = "";
          let name = "";
          if (item.isEcho) {
            url = item.url;
            name = item.url;
          } else {
            url = item.response.data.url;
            name = item.response.data.name;
          }
          fileUrls.push(url);
          fileNames.push(name);
        })
        context.emit("update:fileUrls", fileUrls.join(","));
        context.emit("update:fileNames", fileNames.join(","));
      },
      onError(error, uploadFile, uploadFiles) {
        console.error("error, uploadFile, uploadFiles", error, uploadFile, uploadFiles)
      },
      // 回显图片
      handlePictureCardPreview: (uploadFile) => {
        datas.previewList = datas.newFileList.map(item => item.url)
        console.log("handlePictureCardPreview", datas.previewList);
        datas.dialogImageUrl = `${uploadFile.url}?Authorization=${getToken()}`;
        datas.dialogVisible = true;
      },
      newFileList: [],
      // 回显图片
      dialogImageUrl: "",
      dialogVisible: false
    })

    const methods = {
      // 初始化
      async init() {
      },
      handleChange(value) {
      },
      // 根据url获取上传的文件名
      getUpdateFileName(url) {
        const pos = url.lastIndexOf('/');
        const str = url.substr(pos + 1);
        const lastIndexOf = str.lastIndexOf('_');
        const pname = str.substring(str.lastIndexOf("."));
        if (lastIndexOf > 0) {
          return str.substr(0, lastIndexOf) + pname;
        } else {
          return str;
        }
      },
    }

    watch(() => props.fileUrls, (fileUrls) => {
      datas.newFileList = [];
      if (fileUrls) {
        const list = fileUrls.split(",");
        list.forEach(url => {
          // 截取获取文件名
          const name = methods.getUpdateFileName(url);
          const fileItem = {
            isEcho: true,
            id: getUUID(),
            name: name
          };
          if (url.indexOf("http://") == 0) {
            fileItem.url = url
          } else {
            fileItem.url = datas.baseUrl + `${url}?Authorization=${getToken()}`;
          }
          // console.log("fileItem", fileItem)
          datas.newFileList.push(fileItem);
        })

      }
    }, { immediate: true })

    return {
      upload,
      ...toRefs(datas),
      ...methods
    }
  }
}
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
  border-color: var(--el-color-primary);
}

.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  text-align: center;
}
</style>